import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import LearnPage from "./pages/LearnPage";
import InspectPage from "./pages/InspectPage";
import ArmPage from "./pages/ArmPage";
import MigratePage from "./pages/MigratePage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/learn" element={<LearnPage />} />
        <Route path="/inspect" element={<InspectPage />} />
        <Route path="/inspect/:npub" element={<InspectPage />} />
        <Route path="/arm" element={<ArmPage />} />
        <Route path="/migrate" element={<MigratePage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;